import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const RangeInput = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  error,
  required = false,
  disabled = false,
  hint = "",
  min = 0,
  max = 100,
  style = {},
}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <InputGroup className="mb-3">
        <InputGroup.Text
          className="rounded-right font-weight-bold d-flex justify-content-center"
          style={{ width: "50px" }}
        >
          {value}
        </InputGroup.Text>
        <Form.Control
          name={name}
          type="range"
          style={style}
          className="bg-light"
          disabled={disabled}
          min={min}
          max={max}
          onBlur={onBlur}
          value={value}
          onChange={onChange}
        />
      </InputGroup>
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && (
        <div>
          <small className="text-danger">{error}</small>
        </div>
      )}
    </Form.Group>
  );
};

export default RangeInput;
